<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query.no" clearable placeholder="business.label.no" size="small" type="search" @search-click="refresh"/>
      <vxe-input v-model="query.name" clearable placeholder="business.label.name" size="small" type="search" @search-click="refresh"/>
      <vxe-select v-model="query.operationType" :options="operationTypes" clearable placeholder="business.label.operationType" size="small" style="width: 100%" @change="refresh"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      :height="height"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" fixed="left" title="business.label.no" width="100"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" fixed="left" title="business.label.name" width="100"/>
      <vxe-column :edit-render="{name:'VxeSelect',options:operationTypes}" field="operationType" fixed="left" title="business.label.operationType" width="100"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" fixed="left" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="original" fixed="left" title="business.label.native" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="refundable" title="business.label.refundable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="depositable" title="business.label.depositable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="coding" title="business.label.coding" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="chargeup" title="business.label.chargeup" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="inspectable" title="business.label.inspectable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="producible" title="business.label.producible" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="shortable" title="business.label.shortable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="delegable" title="business.label.delegable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="exchangeable" title="business.label.exchangeable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="invertible" title="business.label.invertible" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="convertible" title="business.label.convertible" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="supplemental" title="business.label.supplemental" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="temporary" title="business.label.temporary" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="supervised" title="business.label.supervised" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="mergeOrder" title="business.label.mergeOrder" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoSubmit" title="business.label.autoSubmit" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoApproval" title="business.label.autoApproval" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoAsn" title="business.label.autoAsn" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoReceiving" title="business.label.autoReceiving" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoAccepting" title="business.label.autoAccepting" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoPutaway" title="business.label.autoPutaway" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoCompletion" title="business.label.autoCompletion" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoRetry" title="business.label.autoRetry" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoInversionApproval" title="business.label.autoInversionApproval" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoReview" title="business.label.autoReview" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoDistribution" title="business.label.autoDistribution" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoHandover" title="business.label.autoHandover" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="autoCleanup" title="business.label.autoCleanup" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, findEnum, saveAll } from '@/api/Api'
import { ENTERPRISE, SCREEN_HEIGHT } from '@/store/mutation-types'
import { OrderType } from '@/api/dto/common/OrderType'

export default {
  name: 'OrderTypeMaintain',
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      data: [],
      query: new OrderType(),
      page: 1,
      size: 20,
      contentSize: 0,
      operationTypes: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editRules: {
        no: [
          { required: true, type: 'string', message: '编号不能为空' }
        ],
        name: [
          { required: true, type: 'string', message: '名称不能为空' }
        ]
      }
    }
  },
  created() {
    findEnum('OperationType').then(res => {
      if (res.success) {
        this.operationTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('orderTypeFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new OrderType(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    add() {
      this.data.push(new OrderType())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.enterprise = this.enterprise
          return item.toJSONObject()
        })
        saveAll('orderTypePersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>